import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AboutUs from "./Pages/AboutUs";
import Contact from "./Pages/Contactus";
import Services from "./Pages/Services";
import Products from "./Pages/Products";
import Innovation from "./Pages/Innovation";
import AppV2 from "./main";

import Navbar from "./components/Navbar";
import Footer from "./Footer";
import "./main.css";

import Login from "./Pages/Login";
import Register from "./Pages/Register";
import Dashboard from "./Pages/Dashboard";
import Jobs from "./Pages/Jobs";
import JobApply from "./Pages/JobApply";
import EmployeeDashboard from "./Pages/EmployeeDashboard";

function App() {

  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user")) || null
  );

  // 🔐 Check employee role from backend
  const isEmployee = (user) => {
    return user?.role === "employee";
  };

  return (
    <>
      <Navbar user={user} setUser={setUser} />

      <Routes>

        {/* Public Pages */}
        <Route path="/" element={<AppV2 />} />
        <Route path="/services" element={<Services />} />
        <Route path="/innovation" element={<Innovation />} />
        <Route path="/products" element={<Products />} />
        <Route path="/jobs" element={<Jobs />} />

        <Route
          path="/apply/:jobType"
          element={<JobApply user={user} />}
        />

        <Route
          path="/apply"
          element={<JobApply user={user} />}
        />

        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />

        {/* Auth Pages */}
        <Route
          path="/login"
          element={<Login setUser={setUser} />}
        />

        <Route
          path="/register"
          element={<Register setUser={setUser} />}
        />

        {/* Normal User Dashboard */}
        <Route
          path="/dashboard"
          element={
            user ? (
              !isEmployee(user)
                ? <Dashboard user={user} />
                : <Navigate to="/employee-dashboard" />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Employee Dashboard */}
        <Route
          path="/employee-dashboard"
          element={
            user ? (
              isEmployee(user)
                ? <EmployeeDashboard user={user} />
                : <Navigate to="/dashboard" />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

      </Routes>

      <Footer />
    </>
  );
}

export default App;